module.exports = require('./lib/ReactWithAddons');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/addons.js
 ** module id = 39
 ** module chunks = 0
 **/